import { fetchApi } from '@/config/axiosSetting';
import {
  GetDamagedVehicleCorrectiveImagesFormTabsParamsType,
  GetDamagedVehicleCorrectiveImagesFormTabsResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedVehicleCorrectiveImagesFormTabs/getDamagedVehicleCorrectiveImagesFormTabs.type';

export const getDamagedVehicleCorrectiveImagesFormTabsFunction = (
  params: GetDamagedVehicleCorrectiveImagesFormTabsParamsType,
): Promise<GetDamagedVehicleCorrectiveImagesFormTabsResponseType> =>
  fetchApi.get(
    `/property/reports/${params.id}/accident_users/damaged/images/corrective/form/entry_tabs/`,
    {
      params: {
        damaged_id: params.damage_id,
      },
    },
  );
